import {OfferList as OffersListBase} from '@yandex-delivery/form/ui/Offers/OffersList/OffersList'
import React from 'react'

import {appConfig} from 'src/shared/config'

import {NoAddressPlaceholder} from '../NoAddressPlaceholder/NoAddressPlaceholder'
import {NoOffersPlaceholder} from '../NoOffersPlaceholder/NoOffersPlaceholder'
import {useOffers} from './hooks'
import type {Props} from './types'

export function OfferList(props: Props): React.ReactElement<Props> {
  const {name, body} = props

  return body === undefined ? <NoAddressPlaceholder /> : <Offers body={body} name={name} />
}

function Offers(props: Required<Props>): React.ReactElement<Required<Props>> {
  const {offers, isValid, isPending, name} = useOffers(props)

  return offers.length === 0 && !isPending ? (
    <NoOffersPlaceholder isPending={isPending} isValid={isValid} />
  ) : (
    <OffersListBase
      country={appConfig.countryCode}
      currencySign={appConfig.currencySign}
      isPending={isPending}
      name={name}
      offers={offers}
    />
  )
}
